var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { memo } from "react";
var SvgSpecializedDeprecated = function SvgSpecializedDeprecated(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    "aria-hidden": "true",
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-428.000000, -44.000000)",
    fill: "#404041"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M428,53 L437,44 L444,44 L444,51 L435,60 L428,53 Z M439.5,50 C440.328427,50 441,49.3284271 441,48.5 C441,47.6715729 440.328427,47 439.5,47 C438.671573,47 438,47.6715729 438,48.5 C438,49.3284271 438.671573,50 439.5,50 Z"
  }))));
};
var Memo = /*#__PURE__*/memo(SvgSpecializedDeprecated);
export { Memo as ReactComponent };
export default __webpack_public_path__ + "transfix-icons/icons/SpecializedDeprecated.f563344cfb66f0d7e46715d66a4e7529.svg";